import React, { useState, useRef, useEffect, memo } from 'react';
import * as THREE from 'three';
import { GetMaterial } from '../fileIO/fileLoader';

export const adapterHeight = [
  32-28+18, // Double Clamp 32 //28:female pyramid height // male pyramid height: 18
  40-28+18, // Double Clamp 40
  45-28+18, // Double Clamp 45 
  50-28+18, // Double Clamp 50
  55-28+18, // Double Clamp 55
  60-28+18, // Double Clamp 60
  75-28+18, // Double Clamp 75
  58-28+18, // Cross Slide 00
  68-28+18, // Cross Slide 10
  78-28+18, // Cross Slide 20
  88-28+18, // Cross Slide 30
  98-28+18, // Cross Slide 40
  108-28+18, // Cross Slide 50
  0 // Female Pyramid
]

const MAssembleAk = memo(({
  activeStep,
  side,
  stumpLength,
  centroidBaseshape,
  oriLowerSurface,
  oriUpperSurface,
  assembleAdapter,
  assembleSocketMl,
  assembleSocketAp,
  assembleSocketSi,
  assembleFlexionExtension,
  assembleAdductionAbduction,
  assembleSocketRotation,
  meshFoot,
  meshKnee,
  callback,
  color,
  colorHigh,
  colorSub
}) => {
  const refSocket = useRef();
  const refGroup = useRef(new THREE.Group());
  const refGroup1 = useRef(new THREE.Group());
  
  let meshPylon    = null;
  let meshPylamid  = null;
  let meshAdapter  = null;
  let meshRotationCenter = null;
  let meshRotationCenter2 = null;
  let meshRotationCenter3 = null;

  const lowerSurface = oriLowerSurface.clone();
  const upperSurface = oriUpperSurface.clone();

  const material = new THREE.MeshLambertMaterial({color: color, transparent: true, opacity: 0.6, side: THREE.DoubleSide});
  const materialHigh = new THREE.MeshBasicMaterial({ color: colorHigh, transparent: true, opacity: 0.6, side: THREE.FrontSide });

  const rotationCenter = [centroidBaseshape.x, -stumpLength-26-assembleSocketSi-adapterHeight[assembleAdapter], centroidBaseshape.z];
  //const inverseRotationCenter = [-rotationCenter[0], -rotationCenter[1], -rotationCenter[2]];
  const [meshLower, setMeshLower] = useState(new THREE.Mesh(lowerSurface, material));
  const [meshUpper, setMeshUpper] = useState(new THREE.Mesh(upperSurface, material));

  // function rotateMesh(ref, rotationCenter, assembleFlexionExtension, assembleAdductionAbduction, assembleSocketRotation) {
  //   ref.current.rotation.x = -assembleFlexionExtension / 180 * Math.PI;
  //   ref.current.rotation.z = assembleAdductionAbduction  / 180 * Math.PI;
  //   ref.current.rotation.y = assembleSocketRotation / 180 * Math.PI;

  //   ref.current.position.x += rotationCenter[0]; // this is offset rotation center, already translated at the beginning as group object
  //   ref.current.position.y += rotationCenter[1];
  //   ref.current.position.z += rotationCenter[2];
  // }

  if (meshPylon==null) {
    var temp = new THREE.Mesh(
      new THREE.CylinderGeometry(15, 15, 350, 32), 
      new THREE.MeshPhongMaterial({ color: 0x9d9d9d, side: THREE.DoubleSide })
    );
    meshPylon = temp;
  }

  if (meshPylamid==null) {
    var temp = new THREE.Mesh(
      new THREE.BoxGeometry(52, 52, 5), 
      new THREE.MeshPhongMaterial({ color: 0x9d9d9d, side: THREE.DoubleSide })
    );
    meshPylamid = temp;
  }

  // stumpLength - 26
  // show rotation center
  if (refGroup.current) {
    refGroup.current.position.x = -assembleSocketMl;
    refGroup.current.position.y = -adapterHeight[assembleAdapter] - assembleSocketSi;
    refGroup.current.position.z = assembleSocketAp;
  }
  if (refGroup1.current) {
    refGroup1.current.position.x = -assembleSocketMl;
    refGroup1.current.position.y = -assembleSocketSi;
    refGroup1.current.position.z = assembleSocketAp;
  }

  // adapter dummy
  const geomAdapter = new THREE.CylinderGeometry( 26, 26, adapterHeight[assembleAdapter], 32 );
  meshAdapter = new THREE.Mesh( geomAdapter, GetMaterial('metal') );
  meshAdapter.position.x = centroidBaseshape.x;
  meshAdapter.position.y = -adapterHeight[assembleAdapter]/2-stumpLength-26;
  meshAdapter.position.z = centroidBaseshape.z;

  const geomRotationCenter = new THREE.CylinderGeometry( 3, 3, 200, 32 );
  meshRotationCenter = new THREE.Mesh( geomRotationCenter, materialHigh );
  meshRotationCenter.rotateZ(Math.PI/2);
  meshRotationCenter.position.x = rotationCenter[0];
  meshRotationCenter.position.y = rotationCenter[1];
  meshRotationCenter.position.z = rotationCenter[2];

  const geomRotationCenter2 = new THREE.CylinderGeometry( 3, 3, 200, 32 );
  meshRotationCenter2 = new THREE.Mesh( geomRotationCenter2, materialHigh );
  //meshRotationCenter2.rotateZ(Math.PI/2);
  meshRotationCenter2.rotateX(Math.PI/2);
  meshRotationCenter2.position.x = rotationCenter[0];
  meshRotationCenter2.position.y = rotationCenter[1];
  meshRotationCenter2.position.z = rotationCenter[2];

  const geomRotationCenter3 = new THREE.CylinderGeometry( 3, 3, 1000, 32 );
  meshRotationCenter3 = new THREE.Mesh( geomRotationCenter3, materialHigh );
  meshRotationCenter3.rotateY(Math.PI/2);
  meshRotationCenter3.position.x = rotationCenter[0];
  meshRotationCenter3.position.y = rotationCenter[1];
  meshRotationCenter3.position.z = rotationCenter[2];

  useEffect(() => {
    if (refSocket.current) {
      // //translation
      // refSocket.current.position.x = assembleSocketMl;
      // refSocket.current.position.z = assembleSocketSi;
      // refSocket.current.position.y = assembleSocketAp;
      
      // //rotation
      // rotateMesh(refSocket, rotationCenter, assembleFlexionExtension, assembleAdductionAbduction, assembleSocketRotation);

      // //We will translate other metric parts, not socket because we need to check socket with leg data.
      // // Leg is not translated, so we need to translate socket to leg.

      // translation, lowerSurface and upperSurface to move it to rotationCenter
      // for (var i = 0; i < lowerSurface.attributes.position.array.length; i++) {
      //   if (i%3 == 0) {
      //     lowerSurface.attributes.position.array[i] += assembleSocketMl;
      //   } else if (i%3 == 1) {
      //     lowerSurface.attributes.position.array[i] += assembleSocketSi;
      //   } else if (i%3 == 2) {
      //     lowerSurface.attributes.position.array[i] += assembleSocketAp;
      //   }
      // }
      // // translation, upperSurface
      // for (var i = 0; i < upperSurface.attributes.position.array.length; i++) {
      //   if (i%3 == 0) {
      //     upperSurface.attributes.position.array[i] += assembleSocketMl;
      //   } else if (i%3 == 1) {
      //     upperSurface.attributes.position.array[i] += assembleSocketSi;
      //   } else if (i%3 == 2) {
      //     upperSurface.attributes.position.array[i] += assembleSocketAp;
      //   }
      // }

      // rotation, lowerSurface around rotationCenter
      lowerSurface.translate(-rotationCenter[0], -rotationCenter[1], -rotationCenter[2])
      upperSurface.translate(-rotationCenter[0], -rotationCenter[1], -rotationCenter[2])

      // Rotation x
      const rotationMatrixX = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(1, 0, 0), Math.PI / 180 * (-assembleFlexionExtension));
      // apply rotation
      lowerSurface.applyMatrix4(rotationMatrixX);
      upperSurface.applyMatrix4(rotationMatrixX);

      // Rotation y
      const rotationMatrixY = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(0, 1, 0), Math.PI / 180 * assembleSocketRotation);
      // apply rotation
      lowerSurface.applyMatrix4(rotationMatrixY);
      upperSurface.applyMatrix4(rotationMatrixY);

      // Rotation z
      const rotationMatrixZ = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(0, 0, 1), Math.PI / 180 * assembleAdductionAbduction);
      // apply rotation
      lowerSurface.applyMatrix4(rotationMatrixZ);
      upperSurface.applyMatrix4(rotationMatrixZ);

      // translate back
      lowerSurface.translate(rotationCenter[0], rotationCenter[1], rotationCenter[2])
      upperSurface.translate(rotationCenter[0], rotationCenter[1], rotationCenter[2])

      // callback(lowerSurface, upperSurface);

      setMeshLower(new THREE.Mesh(lowerSurface, material));
      setMeshUpper(new THREE.Mesh(upperSurface, material));
    }
  }, [assembleFlexionExtension, assembleAdductionAbduction, assembleSocketRotation]);

  return (
    <>
      { (activeStep == 6) && 
      <group ref={refSocket} >
        <primitive key='lower' object={meshLower}/>
        <primitive key='upper' object={meshUpper}/>
      </group> }
      { meshRotationCenter ? <primitive key='rotationCenter' object={meshRotationCenter} scale={[1, 1, 1]} /> : null }
      { meshRotationCenter2 ? <primitive key='rotationCenter2' object={meshRotationCenter2} scale={[1, 1, 1]} /> : null }
      { meshRotationCenter3 ? <primitive key='rotationCenter3' object={meshRotationCenter3} scale={[1, 1, 1]} /> : null }
      <group ref={refGroup1}>
        { meshPylamid ? <primitive key='pylamid' object={meshPylamid} scale={[1, 1, 1]} rotation={[-Math.PI/2,0,0]} position={[centroidBaseshape.x, -stumpLength-28, centroidBaseshape.z]} /> : null}
        { meshAdapter ? <primitive key='adapter' object={meshAdapter} scale={[1, 1, 1]}/> : null}
      </group>
      <group ref={refGroup}>
        { meshKnee ? <primitive key='knee' object={meshKnee} scale={[1, 1, 1]} position={[centroidBaseshape.x, -stumpLength-100, centroidBaseshape.z]}/> : null}
        { meshPylon ? <primitive key='pylon' object={meshPylon} scale={[1, 1, 1]} position={[centroidBaseshape.x, -stumpLength-300, centroidBaseshape.z-10]} /> : null}
        { meshFoot ? <primitive key='foot' object={meshFoot} scale={[-1, 1, 1]} position={[centroidBaseshape.x, -stumpLength-490, centroidBaseshape.z-70]}/> : null}
      </group>
    </>
  )
});

export default MAssembleAk
